import { all, call, put, takeLatest } from 'redux-saga/effects';

import workspaceService from '@app/libs/workspaceService';
import { DOCUMENT_DATA__FETCH_REQUEST } from '@app/store/actionTypes';
import {
  fetchDocumentData,
  fetchDocumentDataFailure,
  fetchDocumentDataSuccess,
} from '@app/store/document/data/actions';
import Document from '@app/store/document/Document';
import { getDocumentsById } from '@app/store/transport-layer/document/documents';

export function* fetchDocumentDataSaga({
  payload: { documentId },
}: ReturnType<typeof fetchDocumentData>) {
  try {
    const document: Document = yield call(getDocumentsById, {
      workspaceId: workspaceService.getWorkspaceId(),
      documentId,
    });
    yield put(
      fetchDocumentDataSuccess({
        document,
      })
    );
  } catch (error) {
    yield put(fetchDocumentDataFailure(error));
  }
}

export default function* saga() {
  yield all([takeLatest(DOCUMENT_DATA__FETCH_REQUEST, fetchDocumentDataSaga)]);
}
